import styled from 'styled-components';
import { device } from '../../styles/devices';

export const MobileController = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  padding-right: 17px;
  padding-left: 19px;
  @media ${device.mobileM} {
    gap: 24px;
  }
  @media ${device.mobileL} {
    gap: 70px;
    padding-right: 0px;
    padding-left: 0px;
  }
  @media ${device.laptop} {
    display: none;
  }
`;

export const DesktopController = styled.div`
  display: none;
  @media ${device.laptop} {
    display: flex;
    gap: 130px;
    align-items: center;
    justify-content: center;
    margin-top: 16px;
    margin-bottom: 44px;
  }
`;

export const Label = styled.p`
  font-family: 'Audi Type';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.003px;
`;

export const PaginationWrapper = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;
